<template lang="pug">
li
  div.form-check
    div.node-info-container.mb-3
      span.px-1(v-if="!leaf" @click="toggleChildren" data-cy="toggle_children")
        i.fas.fa-minus(v-if="childrenVisible")
        i.fas.fa-plus(v-else)
      div.selectable_node.hvr-forward(
        @click="selectValue"
        @mouseover="hover = true"
        @mouseleave="hover = false"
      )
        label.form-check-label.pl-0(v-bind:class="{ marked: mustMark, 'node-leaf': leaf }" :for="catid")
          | {{ label }}
    ul.list-unstyled
      transition(name="fade" v-for="child in children" :key="`transition_${child.catid}`")
        navigation-index-node-vue.font-weight-normal(
          v-show="childrenVisible"
          :key="child.catid"
          v-bind="child"
          :index="index"
          :selected="selected"
          @value-selected="valueSelected"
          @loading-changed="$emit('loading-changed', $event)"
        )
</template>

<script>
import navigation_index_mixin from 'common/mixins/navigation_index'

export default {
  name: 'navigation-index-node-vue',
  props: {
    index: { type: String, default: '' },
    catid: { type: Number, default: 0 },
    label: { type: String, default: '' },
    leaf: { type: Boolean, default: false },
    selected: { type: Number, default: 0 },
  },
  mixins: [navigation_index_mixin],
  data: function () {
    return {
      children: [],
      childrenVisible: false,
      loaded: false
    }
  },
  computed: {
    mustMark() {
      return this.catid == this.selected
    },
  },
  methods: {
    async toggleChildren() {
      this.childrenVisible = !this.childrenVisible
      if (this.childrenVisible && !this.loaded)
        await this.loadChildren()
    },
    async selectValue() {
      this.$emit('value-selected', this.catid, [this.label])
    },
    valueSelected(catid, path) {
      this.$emit('value-selected', catid, [this.label, ...path])
    },
    async loadChildren() {
      this.$emit('loading-changed', true)
      try {
        this.children = await this.retrieveChildren(this.index, this.catid)
        this.loaded = true
      } finally {
        this.$emit('loading-changed', false)
      }
    }
  }
}
</script>
